module.exports = __webpack_public_path__ + "img/title.679d2b11.png";